import { useCallback } from "react";
import { useIntl } from "react-intl";
import { sendAnalyticsInteractionEvent } from "src/analytics/sendAnalyticsEvent";
import { AppleSignIn } from "src/auth/components/AppleSignIn/AppleSignIn";
import { useAuthProviders } from "src/auth/contexts/AuthContext";
import type { AuthType } from "src/auth/utils/session";
import { Button } from "react-aria-components";
import AppleLogo from "src/design-system/icons/AppleLogo.svg?react";
import { messages } from "./AppleSignInButton.messages";

export function AppleSignInButton() {
  const intl = useIntl();
  const { appleLoading, setAuthProvidersLoading } = useAuthProviders();

  const handleClick = useCallback(
    async (signInWithApple: VoidFunction) => {
      setAuthProvidersLoading(true);
      setTimeout(() => {
        setAuthProvidersLoading(false);
      }, 3000);

      const authType: AuthType = "apple";
      sendAnalyticsInteractionEvent({
        category: "UserAccount",
        action: "Click:ThirdPartyAuthButton",
        label: authType,
      });
      // Apple sign in is a bit slow and blocks any other procces execution in the app during the sign in process
      // so we need to wait a bit to set the loading state to false
      await new Promise((resolve) => setTimeout(resolve, 100));
      signInWithApple();
    },
    [setAuthProvidersLoading],
  );
  return (
    <AppleSignIn>
      {({ signInWithApple }) => (
        <Button
          className="flex w-full cursor-pointer items-center justify-center gap-2 rounded-md border-1 border-border bg-black p-3 text-center text-label-md text-text-on-bg-fill data-hovered:bg-neutral-1500"
          onPress={() => {
            handleClick(signInWithApple);
          }}
          isDisabled={appleLoading}
        >
          <AppleLogo className="-mt-1 w-4 text-text-on-bg-fill" />
          <span>{intl.formatMessage(messages.appleLogin)}</span>
        </Button>
      )}
    </AppleSignIn>
  );
}
